<template>
  <div class="oracle-menu">
    <div class="oracle-content">
      <div class="oracle-left">
        <img src="../assets/logo.png" class="logo" />
        <img src="../assets/curve.png" class="curve" alt="">
      </div>
      <div class="oracle-right">
        <div class="item">
          <img src="../assets/tel.png" alt="">
          <div class="line"></div>
          <div>
            <p>+00-1202-235</p>
            <span>hmend@gmail.com</span>
          </div>
        </div>
        <div class="item">
          <img src="../assets/address.png" alt="">
          <div class="line"></div>
          <div>
            <p>Headquartered at No. 26/14, Village 6, </p>
            <span>Wat Chalo Sub-district, Bang Kruai District</span>
          </div>
        </div>
      </div>
    </div>
    <div class="oracle-menubox">
      <div :class="step == 1 ? 'select' : ''" @click="selectMenu(1)">วิสัยทัศน์</div>
      <div :class="step == 2 ? 'select' : ''" @click="selectMenu(2)">
        เกี่ยวกับเรา
      </div>
      <div :class="step == 3 ? 'select' : ''" @click="selectMenu(3)">
        ติดต่อเรา
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Menu",
  props: {
    step: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      index: 0,
    };
  },
  methods: {
    selectMenu(value) {
      this.index = value;
      if (value == this.step) {
        return;
      }
      switch (value) {
        case 1:
          this.$router.push({ path: "/" });
          break;
        case 2:
          this.$router.push({ path: "aboutUs" });
          break;
        case 3:
          this.$router.push({ path: "contact" });
          break;
        default:
          this.$router.push({ path: "/" });
          break;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.oracle-menu {
  .oracle-content {
    display: flex;
    align-items: center;


    .oracle-left {
      margin-left: 360px;
      position: relative;

      .logo {
        position: relative;
        width: 375px;
        height: 48px;
        z-index: 9;
      }

      .curve {
        position: absolute;
        left: 10%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 856px;
        height: 104px;
      }
    }

    .oracle-right {
      padding: 29px 0 29px 200px;
      flex: 1;
      display: flex;
      align-items: center;
      background: #1D2735;
      box-sizing: border-box;

      .item {
        margin-right: 64px;
        display: flex;
        align-items: center;

        img {
          width: 24px;
          height: 24px;
        }

        .line {
          margin: 0 15px;
          width: 1px;
          height: 30px;
          background: #FFFFFF;
        }

        p {
          font-size: 16px;
          font-family: KohinoorBangla, KohinoorBangla;
          color: #FFFFFF;
        }

        span {
          font-size: 16px;
          font-family: KohinoorBangla, KohinoorBangla;
          color: #FFFFFF;
        }
      }
    }
  }



  .oracle-menubox {
    display: flex;
    align-items: center;
    font-size: 18px;
    font-family: KohinoorBangla, KohinoorBangla;
    font-weight: 500;
    color: #999999;
    padding: 28px 360px;
    cursor: pointer;
    background: #F6F6F6;

    div {
      margin-right: 120px;
    }
  }

  .select {
    font-weight: bold;
    color: #F56604;
  }
}
</style>
